import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { sharedMessages } from '../../utils/uiMessages';

const CUSTOM_OPTION = '__custom__';
const PRESET_VALUES = [
  'Patent prosecution',
  'Legal matter',
  'Research',
];

const messages = defineMessages({
  chooseMatterTitle: {
    id: 'Choose a matter title',
    defaultMessage: 'Choose a matter title',
  },
  customMatterTitle: {
    id: 'Custom matter title',
    defaultMessage: 'Custom matter title',
  },
  matterTitleHelp: {
    id: 'Choose a standard title or enter your own.',
    defaultMessage: 'Choose a standard title or enter your own.',
  },
  useFreeText: {
    id: 'Use free text',
    defaultMessage: 'Use free text',
  },
});

function deriveMode(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) {
    return '';
  }
  return PRESET_VALUES.includes(trimmed) ? trimmed : CUSTOM_OPTION;
}

export default function MatterTitleField({ value, onChange, required = false }) {
  const intl = useIntl();
  const [mode, setMode] = useState(() => deriveMode(value));

  useEffect(() => {
    setMode(deriveMode(value));
  }, [value]);

  return (
    <>
      <label className="patent-entry__field">
        <span className="patent-entry__label">
          {intl.formatMessage(sharedMessages.matterTitle)}
        </span>
        <select
          className="patent-entry__input"
          value={mode}
          onChange={(event) => {
            const nextMode = event.target.value;
            setMode(nextMode);
            if (PRESET_VALUES.includes(nextMode)) {
              onChange(nextMode);
              return;
            }
            if (nextMode === CUSTOM_OPTION) {
              if (PRESET_VALUES.includes(String(value || '').trim())) {
                onChange('');
              }
              return;
            }
            onChange('');
          }}
          required={required && !String(value || '').trim()}
        >
          <option value="">
            {intl.formatMessage(messages.chooseMatterTitle)}
          </option>
          {PRESET_VALUES.map((option) => (
            <option key={option} value={option}>
              {intl.formatMessage({
                id: option,
                defaultMessage: option,
              })}
            </option>
          ))}
          <option value={CUSTOM_OPTION}>
            {intl.formatMessage(messages.useFreeText)}
          </option>
        </select>
        <span className="patent-entry__help">
          {intl.formatMessage(messages.matterTitleHelp)}
        </span>
      </label>

      {mode === CUSTOM_OPTION ? (
        <label className="patent-entry__field">
          <span className="patent-entry__label">
            {intl.formatMessage(messages.customMatterTitle)}
          </span>
          <input
            className="patent-entry__input"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            required={required}
          />
        </label>
      ) : null}
    </>
  );
}
